/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { MIN_DIMENSION_SIZE } from "../common/constants";

export const getRangeString = (size: any) =>
  `${size.category} ${size.sizeRange ? size.sizeRange : ""}`;

export const isWidthAndHeightValid = ({ width, height }: any) =>
  width !== "" &&
  Number(width) >= MIN_DIMENSION_SIZE &&
  height !== "" &&
  Number(height) >= MIN_DIMENSION_SIZE;

export const groupByPreset = (sizesAndQuantities: any) =>
  sizesAndQuantities.reduce((acc: any, item: any, index: any) => {
    const { preset, quantity } = item;
    return {
      ...acc,
      [preset]: {
        items: [...(acc[preset]?.items || []), { ...item, index }],
        count: (acc[preset]?.count || 0) + quantity,
        price: item.unitPrice
          ? (acc[preset]?.price || 0) + Number(item.unitPrice) * quantity
          : acc[preset]?.price || 0,
        preset
      }
    };
  }, {});

export const getImageMetadataInfo = ({ metadata, sizesAndQuantities, minDpi, artwork }: any) => {
  if (!metadata) return null;

  return {
    aspect_ratio: metadata.aspectRatio,
    resolution_width: metadata.width,
    resolution_height: metadata.height,
    size_and_quantities: sizesAndQuantities,
    max_width: metadata.maxWidth,
    max_height: metadata.maxHeight,
    max_sheet_width: metadata.maxSheetWidth,
    max_sheet_height: metadata.maxSheetHeight,
    min_dpi: minDpi,
    file_name: artwork.name,
    file_size: artwork.fileSize,
    file_type: artwork.fileType
  };
};

export const getProportionalEdge = ({ value, field, aspectRatio, currentDimensions }: any) => {
  if (!aspectRatio) return currentDimensions[field];

  const factor = field === "height" ? 1 / aspectRatio : aspectRatio;
  const otherEdge = Math.round(value * factor * 100) / 100;

  return otherEdge.toFixed(2) || null;
};
